import { render, staticRenderFns } from "./RedSeal.vue?vue&type=template&id=6a0cb33e&scoped=true&"
import script from "./RedSeal.vue?vue&type=script&lang=js&"
export * from "./RedSeal.vue?vue&type=script&lang=js&"
import style0 from "./RedSeal.vue?vue&type=style&index=0&id=6a0cb33e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0cb33e",
  null
  
)

export default component.exports